import { render, staticRenderFns } from "./AnimatedButton.vue?vue&type=template&id=2de2ebee&scoped=true&"
import script from "./AnimatedButton.vue?vue&type=script&lang=js&"
export * from "./AnimatedButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2de2ebee",
  null
  
)

export default component.exports